module.exports = __webpack_public_path__ + "img/lg_ring_r_0_1_1@2x.d0d6f945.png";